module.exports = __webpack_public_path__ + "static/CleanAir-Desktop-Header-1920x340-Curve-DataHub-2x-42b25cb4c292183756d1fd17868d5219.png";